<!-- 停车场基础信息上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carList": [
                    {
                        "addBy": "admin",
                        "addTime": "20170929160020",
                        "carColor": 0,
                        "carLicenseColor": 0,
                        "carLicenseNumber": "津M95621",
                        "carLicenseType": 0,
                        "carLogo": 0,
                        "carOwnType": 0,
                        "carSeq": 7,
                        "carSizeType": 0,
                        "carType": 0,
                        "customerSeq": 5,
                        "deleted": false,
                        "similarPlates": ""
                    }
                ],
                "cmd": "reportCar",
                "parkCode": "2KM9J7GC",
                "reportTime": "20170929160020"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报开票信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportInvoice",
                precondition: "无",
                fitSystem: "VEMS传统停车场,云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'invoiceTitle', info2: '是', info3: 'String', info4: '发票抬头' },
                        { info1: 'invoiceBillCode', info2: '否', info3: 'String', info4: '开票流水号' },
                        { info1: 'invoiceNumber', info2: '否', info3: 'String', info4: '发票号码' },
                        { info1: 'invoiceCode', info2: '否', info3: 'String', info4: '发票代码' },
                        { info1: 'invoiceValue', info2: '否', info3: 'BigDecimal', info4: '发票金额' },
                        { info1: 'invoiceStatus', info2: '否', info3: 'String', info4: '开票状态 0 开票中 1 开票成功 2 冲红 3 作废 4开票失败' },
                        { info1: 'invoicePlatFromName', info2: '否', info3: 'String', info4: '开票商' },
                        { info1: 'invoiceBillType', info2: '否', info3: 'String', info4: '0蓝票 1红票' },
                        { info1: 'invoiceTitleType', info2: '否', info3: 'String', info4: '0个人1企业' },
                        { info1: 'invoiceIdentifying', info2: '否', info3: 'String', info4: '开票标识' },
                        { info1: 'invoicePdf', info2: '否', info3: 'String', info4: '发票pdf地址' },
                        { info1: 'invoiceImg', info2: '否', info3: 'String', info4: '发票图片' },
                        { info1: 'billCodes', info2: '否', info3: 'String', info4: '开票账单列表' },
                   
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/invoice/reportInvoice.vue